/* @flow */

import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import withErrorHandler from '../utils/withErrorHandler';
import withI18n from '../utils/withI18n';
import FlexBox from './FlexBox';
import Icon from './Icon';

const NoticeWrap = styled(FlexBox)`
  width: 100%;
  min-width: ${({ theme }) => theme.minWidth};
  padding: 15px 0;
  background: rgba(11, 14, 17, 1);
`;

const NoticeBox = styled(FlexBox)`
  background: rgba(240, 185, 11, 0.15);
  border-radius: 3px;
  padding: 18px 20px;
  line-height: 100%;
  font-size: 14px;
  width: ${({ theme, isBisicTradePage }) => isBisicTradePage ? theme.basictTradePageMaxWidth : theme.maxWidth};
  color: rgba(240, 185, 11, 1);
`;

const NoticeTitle = styled.p`
  padding: 0 10px;
  margin: 0;
  color: rgba(240, 185, 11, 1);
`;

const DetailLink = styled.a`
  color: #fff;
  margin-left: 30px;
  & :hover {
    color: ${({ theme }) => theme.emergencyNotice.detailLinkColor};
    text-decoration: underline;
  }
  & :visited {
    color: #fff;
  }
`;

const CloseButton = styled.span`
  cursor: pointer;
`;

const mapStateToProps = ({ news, locale }) => ({ news, locale });

type Props = {
  i18n: Object,
  news: Object,
  locale?: string,
  isBisicTradePage?: boolean,
  shouldHeaderFixed?: boolean,
  isShowEmergencyNotice?: boolean,
};

type State = { noticeData: Object, isShow?: boolean };

export default
@withI18n
@withErrorHandler
@connect(mapStateToProps)
class UrgentNotice extends React.Component<Props, State> {
  static defaultProps = {
    i18n: {},
    news: {},
    locale: 'en',
    isBisicTradePage: false,
    shouldHeaderFixed: false,
  };

  state = { noticeData: {}, isShow: false };

  componentDidMount() {
    const { noticeData } = this.state;
    if (noticeData) {
      this.setState({ isShow: false });
    }
  }

  static getDerivedStateFromProps({ news, locale }: Props) {
    const notice = {
      title: '',
      url: '',
    };

    if (!news[locale]) return null; // prevent error.
    news[locale].map(item => {
      if (item.isEmergency) {
        notice.title = item.detail;
        notice.url = item.url;
        return true;
      }
      return null;
    });
    return {
      noticeData: notice,
    };
  }

  _close = () => {
    this.setState({ isShow: false });
  };

  render() {
    const {
      i18n, isBisicTradePage, shouldHeaderFixed, isShowEmergencyNotice,
    } = this.props;
    const { isShow, noticeData } = this.state;
    let NoticeHtml;
    if (isShow && isShowEmergencyNotice) {
      NoticeHtml = (
        <NoticeWrap justify="center" margin={shouldHeaderFixed ? '60px 0 0 0' : '0px'}>
          <NoticeBox isBisicTradePage={isBisicTradePage} justify="space-between" align="center">
            <FlexBox justify="space-between" align="center">
              <Icon type="prompt-o" color="rgba(240, 185, 11, 1)" size={23} />
              <NoticeTitle>{noticeData.title}</NoticeTitle>
              <DetailLink href={noticeData.url} target="_blank">
                {i18n.gengduo || 'More'}
              </DetailLink>
            </FlexBox>
            <CloseButton onClick={this._close}>
              <Icon type="Close-x" color="rgba(240, 185, 11, 1)" size={16} />
            </CloseButton>
          </NoticeBox>
        </NoticeWrap>
      );
    } else {
      NoticeHtml = null;
    }

    return NoticeHtml;
  }
}
